import i18n from '../i18n';
export const formatCurrency = (data) => {
    if (data === undefined || data === null)
        return '';
    const amount = typeof data === 'string' ? parseFloat(data) : data;
    if (Number.isNaN(amount))
        return '';
    const positiveAmount = Math.abs(amount);
    const val = positiveAmount
        .toLocaleString(`${i18n.language}-CA`, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })
        .replace(' ', '\u202F');
    return amount < 0 ? `(${val})` : val;
};
export const formatCurrencyNoDecimals = (data) => {
    if (data === undefined || data === null)
        return '';
    const amount = typeof data === 'string' ? parseFloat(data) : data;
    if (Number.isNaN(amount))
        return '';
    const positiveAmount = Math.abs(amount);
    const val = positiveAmount
        .toLocaleString(`${i18n.language}-CA`, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
        .replace(' ', '\u202F');
    return amount < 0 ? `(${val})` : val;
};
export const formatCurrencyNoDecimalsNoZero = (data) => {
    if (data === undefined || data === null)
        return '';
    const amount = typeof data === 'string' ? parseFloat(data) : data;
    if (Number.isNaN(amount))
        return '';
    if (amount === 0)
        return i18n.language === 'fr' ? '- $' : '$-';
    const positiveAmount = Math.abs(amount);
    const val = positiveAmount
        .toLocaleString(`${i18n.language}-CA`, {
        style: 'currency',
        currency: 'CAD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    })
        .replace(' ', '\u202F');
    return amount < 0 ? `(${val})` : val;
};
export const formatCurrencyToNearestUpperMultipleToNoDecimals = (data, roundUpTo) => formatCurrencyNoDecimals(Math.ceil(data / roundUpTo) * roundUpTo);
export const formatCurrencyRoundedUpToNoDecimals = (data) => formatCurrencyNoDecimals(Math.ceil(data));
